import { Injectable } from '@angular/core';

import { RequestService } from './request.service';

@Injectable()
export class UserService {
  public account: any = null;

  constructor(public requestService: RequestService) {
  }

  getProfile(force = false) {
    if (this.account && this.account.error) {
      force = true;
    }

    return new Promise((resolve, reject) => {
      if (!force && this.account) {
        resolve(this.account);
        return;
      }

      this.requestService
      .get('/api/profile')
      .then((response) => {
        this.account = response;
        resolve(response);
      }, (error) => {
        this.account = null;
        reject(null);
      });
    });
  }

  hasRole(role) {
    if (!role) {
      return true;
    }
    if (!this.account || this.account.error) {
      return false;
    }

    if (typeof role === 'object') {
      return this.hasRoleFromArray(role);
    }
    return this.hasRoleFromString(role);
  }

  hasRoleFromArray(roles) {
    for (let role of roles) {
      if (this.hasRoleFromString(role)) {
        return true;
      }
    }
    return false;
  }

  hasRoleFromString(role) {
    for (let currentRole of this.account.roles) {
      if (currentRole === 'ROLE_SUPER_ADMIN') {
        return true;
      }
      if (currentRole === role) {
        return true;
      }
    }

    return false;
  }

  getNotifications() {
    return this.requestService.get('/api/notifications');
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/user.service.ts